<template>
  <b-dropdown
    size="sm"
    id="ddown_light"
    dropleft
    variant="light"
    class="m-0"
    no-caret
    v-if="!preview"
  >
    <template slot="button-content">
      <font-awesome-icon icon="ellipsis-v"></font-awesome-icon>
    </template>
    <b-dropdown-item v-if="editable" @click="onEdit">Editar</b-dropdown-item>
    <b-dropdown-item @click="onDelete">Eliminar</b-dropdown-item>
  </b-dropdown>
</template>
<script>
export default {
  name: "options-element",
  props: {
    indexElement: { type: Number },
    indexColumn: { type: Number, default: null },
    areColumns: { type: Boolean, default: false },
    editable: { type: Boolean, default: false }
  },
  methods: {
    onDelete() {
      this.$swal
        .fire({
          text: "¿Está Seguro de Eliminar el Elemento?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#285c4d",
          cancelButtonColor: "#aaa",
          confirmButtonText: "Sí, Eliminar",
          cancelButtonText: "No, Cancelar"
        })
        .then(result => {
          if (result.value) {
            this.$store.dispatch("constructor/dropElement", {
              indexElement: this.indexElement,
              indexColumn: this.indexColumn
            });
          }
        });
    },
    onEdit() {
      this.$emit("edit-clicked");
    }
  },
  computed: {
    preview: function() {
      return this.$store.getters["constructor/getFlagPreview"];
    }
  }
};
</script>